import React from 'react';

class SaleOrderAjaxSuccess extends React.Component{
    render() {

        let date = sessionStorage.getItem('date') || false;
        date = date ? date.replace(' ', '') : date;// убирает лишние пробелы
        let customerName = sessionStorage.getItem('customerName') || false;
        let orderId = sessionStorage.getItem('orderId') || false;


        console.log({date,customerName,orderId});
        debugger

        // if (orderId === this.props.match.params.order_id && date && customerName){
            return (
                <div>
                    <h2>Заказ сформирован</h2>
                    <div>
                        Уважаемый (-ая) {customerName}!<br/><br/>

                        Благодарим Вас за оформленный заказ № {orderId} от {date}.<br/>
                        Подробную информацию о заказе мы выслали на указанную Вами электронную почту.<br/>
                        Если в течение 30 минут после оформления заказа мы Вам не перезвонили, убедительно просим проверить указанный Вами номер телефона и связаться с нами.<br/>
                    </div>
                </div>
            );
        // } else {
        //     window.location.href = '/catalog/';
        // }


    }
}

export default SaleOrderAjaxSuccess;